import LeftSide from './Component/leftSide';
import './App.css';
import MiddleSide from './Component/middleSide';
import RightSide from './Component/rightSide';

function App() {
  return (
    <div className='App'>
      <div className='leftSideHome'>
        <LeftSide />
      </div>
      <div className='middleSideHome'>
        <MiddleSide/>
      </div>
      <div className='rightSideHome'>
        <RightSide/>
      </div>
    </div>
  );
}

export default App;
